<div class="row">
  <div class="col-md-12">
    <section class="header-info">
      <div class="d-flex" *ngIf="invoiceTemplateModel.logoAlignment=='Left'">
        <div class="col-md-4">
          <div class="img-placeholder" style="width: 100%">
            <img
              src="{{ businessInfo.Logo ? businessInfo.Logo : 'assets/images/grey-square.png' }}"
              style="width: 150px"
            />
          </div>

          <div
            class="transaction-details"
            *ngFor="let item of manualInvoicePayments"
          >
            <div class="form-group flex flex-col gap-1">
              <label>Amount Paid</label>
              <strong>$ {{item.amountPaid}}</strong>
              <span
                class="tag-pill uppercase"
                [class]="'tag-'+ manualInvoice.Status.toLocaleLowerCase()"
                >{{ manualInvoice.Status }}</span
              >
            </div>
            <div class="form-group flex flex-col gap-1">
              <label>Transaction ID</label>
              <span>{{item.transactionId}}</span>
            </div>
            <div class="form-group flex flex-col gap-1">
              <label>Payment Date</label>
              <span>{{item.date | date:'MM/dd/yyyy'}}</span>
            </div>
            <div class="form-group flex flex-col gap-1">
              <label>Payment Method</label>
              <span>{{item?.paymentMethodTypeName || '-none-'}}</span>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="form-row">
            <div class="form-group col-md-12">
              <label
                *ngIf="locationData && locationData.BranchName && !locationData.IsLocationNameDisplayed"
                [style.color]="invoiceTemplateModel.fontColor"
                style="width: 150px"
                >Location</label
              >
              <strong> {{locationData ? locationData.BranchName : ''}}</strong>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Business Name</label
              ><br />
              <strong
                >{{ businessInfo.BusinessName + (locationData ? ' - ' +
                locationData.BranchName : '') }}</strong
              >
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Address</label
              >
              <br />
              <strong
                >{{ businessInfo.Address1 }}, {{ businessInfo.City }},
                {{businessInfo.StateId}} {{ businessInfo.PostalCode
                }}{{businessInfo.CountryCode ? ' ' + businessInfo.CountryCode :
                ''}}</strong
              >
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Contact Number</label
              >
              <br />
              <strong>{{ businessInfo.ContactNumber }}</strong>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label
                [style.color]="invoiceTemplateModel.fontColor"
                style="width: 150px"
                >Invoice #</label
              >
              <strong
                >{{ manualInvoice.InvoiceNumber ? manualInvoice.InvoiceNumber :
                '000-000-0000' }}</strong
              >
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label
                [style.color]="invoiceTemplateModel.fontColor"
                style="width: 150px"
                >Invoice Date</label
              >
              <strong
                >{{ manualInvoice.InvoiceDate | date:'MM/dd/yyyy'}}</strong
              >
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label
                [style.color]="invoiceTemplateModel.fontColor"
                style="width: 150px"
                >Due Date</label
              >
              <strong>{{ manualInvoice.DueDate | date:'MM/dd/yyyy'}}</strong>
            </div>
          </div>
          <div class="form-row" *ngIf="paymentData">
            <div class="form-group col-md-12">
              <label
                [style.color]="invoiceTemplateModel.fontColor"
                style="width: 150px"
                >Transaction Date</label
              >
              <strong
                >{{ paymentData.date | date: 'MM/dd/yyyy hh:mm:ss' }}</strong
              >
            </div>
          </div>
          <div class="form-row" *ngIf="customerSig">
            <div class="form-group d-flex justify-content-between">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Customer Signature</label
              >
              <strong
                ><img
                  [src]="customerSig.signatureUrl"
                  class="img"
                  style="width: 100%"
              /></strong>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Bill to :
              </label>
              <div *ngIf="customerInfo.CustomerTypeId == 1">
                {{ customerInfo.FirstName }} {{ customerInfo.LastName }}
              </div>
              <div *ngIf="customerInfo.CustomerTypeId == 2">
                {{ customerInfo.BusinessName }}
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Customer Address</label
              >
              <div>{{ customerAddress }}</div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Additional Details :</label
              >
            </div>
            <div
              class="form-group col-md-12"
              *ngFor="let field of customFieldValues;let i = index;"
            >
              <label
                [style.color]="invoiceTemplateModel.fontColor"
                style="width: 150px"
                *ngIf="field.fieldDataType === 104"
                >{{field.fieldName}}</label
              >
              <!-- <cj-checkbox
                *ngIf="field.fieldDataType === 104"
                id="customFieldId{{i}}"
                name="customfield[{{ i }}]"
                style="pointer-events: none;"
                size="small"
                disabled="true"
                [ngModel]="field.fieldValue"
              ></cj-checkbox> -->
              <strong
                [style.color]="invoiceTemplateModel.fontColor"
                *ngIf="field.fieldDataType === 104"
                >{{ field.fieldValue && field.fieldValue === 'true' ? 'Yes' :
                'No' }}</strong
              >
              <label
                [style.color]="invoiceTemplateModel.fontColor"
                style="width: 150px"
                *ngIf="field.fieldDataType !== 104"
                >{{field.fieldName}}</label
              ><strong
                [style.color]="invoiceTemplateModel.fontColor"
                *ngIf="field.fieldDataType !== 104"
                >{{ field.fieldValue }}</strong
              >
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Notes :</label
              >
              <div>{{ manualInvoice.Notes }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex" *ngIf="invoiceTemplateModel.logoAlignment=='Right'">
        <div class="col-md-8">
          <div class="form-row">
            <div class="form-group col-md-12">
              <label
                [style.color]="invoiceTemplateModel.fontColor"
                style="width: 150px"
                >Location</label
              >
              <strong> {{locationData ? locationData.BranchName : ''}}</strong>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Business Name</label
              ><br />
              <strong
                >{{ businessInfo.BusinessName + (locationData ? ' - ' +
                locationData.BranchName : '') }}</strong
              >
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Address</label
              >
              <br />
              <strong
                >{{ businessInfo.Address1 }}, {{ businessInfo.City }},
                {{businessInfo.StateId}} {{ businessInfo.PostalCode
                }}{{businessInfo.CountryCode ? ' ' + businessInfo.CountryCode :
                ''}}</strong
              >
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label
                [style.color]="invoiceTemplateModel.fontColor"
                style="width: 150px"
                >Invoice #</label
              >
              <strong
                >{{ manualInvoice.InvoiceNumber ? manualInvoice.InvoiceNumber :
                '000-000-0000' }}</strong
              >
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label
                [style.color]="invoiceTemplateModel.fontColor"
                style="width: 150px"
                >Invoice Date</label
              >
              <strong
                >{{ manualInvoice.InvoiceDate | date:'MM/dd/yyyy'}}</strong
              >
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label
                [style.color]="invoiceTemplateModel.fontColor"
                style="width: 150px"
                >Due Date</label
              >
              <strong>{{ manualInvoice.DueDate | date:'MM/dd/yyyy'}}</strong>
            </div>
          </div>
          <div class="form-row" *ngIf="paymentData">
            <div class="form-group col-md-12">
              <label
                [style.color]="invoiceTemplateModel.fontColor"
                style="width: 150px"
                >Transaction Date</label
              >
              <strong
                >{{ paymentData.date | date: 'MM/dd/yyyy hh:mm:ss' }}</strong
              >
            </div>
          </div>
          <div class="form-row" *ngIf="customerSig">
            <div class="form-group d-flex justify-content-between">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Customer Signature</label
              >
              <strong
                ><img
                  [src]="customerSig.signatureUrl"
                  class="img"
                  style="width: 100%"
              /></strong>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Bill to :
              </label>
              <div *ngIf="customerInfo.CustomerTypeId == 1">
                {{ customerInfo.FirstName }} {{ customerInfo.LastName }}
              </div>
              <div *ngIf="customerInfo.CustomerTypeId == 2">
                {{ customerInfo.BusinessName }}
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Customer Address</label
              >
              <div>{{ customerAddress }}</div>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="img-placeholder" style="width: 100%">
            <label for="additemfile">
              <img
                src="{{ businessInfo.Logo ? businessInfo.Logo : 'assets/images/grey-square.png' }}"
                style="width: 150px"
              />
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="invoiceTemplateModel.logoAlignment=='Center'">
        <div class="row">
          <div class="col-md-12">
            <div class="img-placeholder" style="width: 100%">
              <label for="additemfile">
                <img
                  src="{{ businessInfo.Logo ? businessInfo.Logo : 'assets/images/grey-square.png' }}"
                  style="width: 150px"
                />
              </label>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="form-row">
              <div class="form-group col-md-12">
                <label
                  [style.color]="invoiceTemplateModel.fontColor"
                  style="width: 150px"
                  >Location</label
                >
                <strong>
                  {{locationData ? locationData.BranchName : ''}}</strong
                >
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label [style.color]="invoiceTemplateModel.fontColor"
                  >Business Name</label
                ><br />
                <strong
                  >{{ businessInfo.BusinessName + (locationData ? ' - ' +
                  locationData.BranchName : '') }}</strong
                >
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label [style.color]="invoiceTemplateModel.fontColor"
                  >Address</label
                >
                <br />
                <strong
                  >{{ businessInfo.Address1 }}, {{ businessInfo.City }},
                  {{businessInfo.StateId}} {{ businessInfo.PostalCode
                  }}{{businessInfo.CountryCode ? ' ' + businessInfo.CountryCode
                  : ''}}</strong
                >
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label
                  [style.color]="invoiceTemplateModel.fontColor"
                  style="width: 150px"
                  >Invoice #</label
                >
                <strong
                  >{{ manualInvoice.InvoiceNumber ? manualInvoice.InvoiceNumber
                  : '000-000-0000' }}</strong
                >
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label
                  [style.color]="invoiceTemplateModel.fontColor"
                  style="width: 150px"
                  >Invoice Date</label
                >
                <strong
                  >{{ manualInvoice.InvoiceDate | date:'MM/dd/yyyy'}}</strong
                >
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label
                  [style.color]="invoiceTemplateModel.fontColor"
                  style="width: 150px"
                  >Due Date</label
                >
                <strong>{{ manualInvoice.DueDate | date:'MM/dd/yyyy'}}</strong>
              </div>
            </div>
            <div class="form-row" *ngIf="paymentData">
              <div class="form-group col-md-12">
                <label
                  [style.color]="invoiceTemplateModel.fontColor"
                  style="width: 150px"
                  >Transaction Date</label
                >
                <strong
                  >{{ paymentData.date | date: 'MM/dd/yyyy hh:mm:ss' }}</strong
                >
              </div>
            </div>
            <div class="form-row" *ngIf="customerSig">
              <div class="form-group d-flex justify-content-between">
                <label [style.color]="invoiceTemplateModel.fontColor"
                  >Customer Signature</label
                >
                <strong
                  ><img
                    [src]="customerSig.signatureUrl"
                    class="img"
                    style="width: 100%"
                /></strong>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label [style.color]="invoiceTemplateModel.fontColor"
                  >Bill to :
                </label>
                <div *ngIf="customerInfo.CustomerTypeId == 1">
                  {{ customerInfo.FirstName }} {{ customerInfo.LastName }}
                </div>
                <div *ngIf="customerInfo.CustomerTypeId == 2">
                  {{ customerInfo.BusinessName }}
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label [style.color]="invoiceTemplateModel.fontColor"
                  >Customer Address</label
                >
                <div>{{ customerAddress }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <div class="invoice-main pt-4 shadow">
      <section class="items-list px-3">
        <table>
          <thead [style.background]="invoiceTemplateModel.accentColor">
            <tr>
              <th style="width: 45%">Item / Service</th>
              <th style="width: 10%">Unit Cost</th>
              <th style="width: 10%">Quantity</th>
              <th style="width: 10%">Is Tax Exempt</th>
              <!-- <th style="width:10%">Tax Exempt</th> -->
              <th style="width: 10%" class="text-right">Line Total</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of invoiceItems">
              <td [class.with-description]="item.ServiceDescription">
                <div>
                  {{ item.ItemName }}
                  <div class="item-description">
                    <div *ngIf="item.ServiceDescription">
                      {{ item.ServiceDescription }}
                    </div>

                    <ng-container *ngIf="getL2L3Description(item)">
                      <br />
                      <div class="l2l3-description">
                        <span *ngIf="item.TaxAmount"
                          >Tax Amount: {{ item.TaxAmount }}</span
                        >
                        <span *ngIf="item.TaxType"
                          >Tax Indicator: {{ item.TaxType }}</span
                        >
                        <span *ngIf="item.ProductCode"
                          >Purchase ID: {{ item.ProductCode }}</span
                        >
                        <span *ngIf="item.ItemCommodityCode"
                          >Commodity Code: {{ item.ItemCommodityCode }}</span
                        >
                        <span *ngIf="item.UnitOfMeasure"
                          >Unit of Measure: {{ item.UnitOfMeasure }}</span
                        >
                        <span *ngIf="item.DiscountAmount"
                          >Discount: {{ item.DiscountAmount }}</span
                        >
                        <span *ngIf="item.TaxTreatment"
                          >Tax Treatment: {{ item.TaxTreatment }}</span
                        >
                      </div>
                    </ng-container>
                  </div>
                </div>
              </td>
              <td>$ {{ item.Rate ? item.Rate.toFixed(2) : '0.00' }}</td>
              <td>{{ item.Quantity }}</td>
              <td>{{ item.IsTaxExempt ? 'Yes' : 'No' }}</td>
              <!-- <td>{{ item.IsTaxExempt ? item.Amount.toFixed(2) : '' }}</td> -->
              <td class="text-right">
                <strong
                  >$ {{ item.Amount ? item.Amount.toFixed(2) : '0.00' }}</strong
                >
              </td>
            </tr>
          </tbody>
        </table>
        <div *ngIf="workOrderData.length != 0" class="d-flex">
          <table class="table table-sm">
            <thead>
              <tr>
                <td style="font-weight: bold">Service Name</td>
                <td style="font-weight: bold">Service Price</td>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let group of workOrderServiceItem">
                <td>{{group.ServiceName}}</td>

                <td></td>
                <td>{{'$' + group.Price}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </section>
      <section class="actions-totals pt-1 pb-3">
        <div class="d-flex">
          <div class="col-md-8">
            <div class="form-group" *ngIf="assigndEmployees.length > 0">
              <label [style.color]="invoiceTemplateModel.fontColor"
                >Assigned Employees/Staff</label
              >
              <ul>
                <li *ngFor="let item of assigndEmployees">
                  <small class="xsmall"
                    ><strong>{{item.employeeName}}</strong> {{ item.emailAddress
                    }} / {{ item.phoneNumber ? item.phoneNumber : 'N / A'
                    }}</small
                  ><br />
                </li>
              </ul>
            </div>
          </div>
          <div class="w-full">
            <div class="form-group">
              <div class="d-flex justify-content-between">
                <label [style.color]="invoiceTemplateModel.fontColor"
                  ><strong>Line Total</strong></label
                >
                <strong
                  >$ {{ manualInvoice.TotalAmount ?
                  manualInvoice.TotalAmount.toFixed(2) : '0.00' }}</strong
                >
              </div>

              <div class="d-flex justify-content-between">
                <label [style.color]="invoiceTemplateModel.fontColor"
                  ><strong>Gross Total</strong></label
                >
                <strong
                  >$ {{ grossTotal ? grossTotal.toFixed(2) : '0.00' }}</strong
                >
              </div>
              <div class="d-flex justify-content-between">
                <label [style.color]="invoiceTemplateModel.fontColor">
                  <strong>Partial Amount</strong>
                </label>
                <strong *ngIf="partialPayment">
                  {{ partialPayment.partialDueType === 'USD' ? '$' : '%' }} {{
                  partialPayment.partialDue ?
                  partialPayment.partialDue.toFixed(2) : '0.00' }}
                </strong>
                <strong *ngIf="!partialPayment">-</strong>
              </div>
            </div>
            <hr />
            <strong [style.color]="invoiceTemplateModel.fontColor"
              >Adjustments</strong
            >
            <div class="form-group" *ngIf="totalDeposits > 0">
              <div class="d-flex justify-content-between">
                <label>Deposits</label>
                <strong> $ {{ totalDeposits.toFixed(2) }}</strong>
              </div>
            </div>
            <div class="form-group pt-2">
              <div class="d-flex justify-content-between">
                <label>Discount</label>
                <strong>
                  <span *ngIf="manualInvoice.DiscountType === '$'">$</span>
                  {{ manualInvoice.Discount ? manualInvoice.Discount.toFixed(2)
                  : '0.00' }}
                  <span *ngIf="manualInvoice.DiscountType === '%'">%</span>
                </strong>
              </div>
            </div>
            <div class="form-group" *ngIf="displayTipAmt">
              <div class="d-flex justify-content-between">
                <label [style.color]="invoiceTemplateModel.fontColor"
                  >Tip</label
                >
                <span class="text-danger"
                  >Tip Amount $ {{ tipAmt.toFixed(2) }}</span
                >
              </div>
            </div>
            <div class="form-group">
              <div class="d-flex justify-content-between">
                <label [style.color]="invoiceTemplateModel.fontColor">
                  {{ manualInvoice.UpchargeName === 'Custom upcharge' ?
                  'Upcharge' : manualInvoice.UpchargeName }}
                </label>
                <strong>
                  <span *ngIf="manualInvoice.UpchargeType === '$'">$</span>
                  {{ manualInvoice.Upcharge ? manualInvoice.Upcharge.toFixed(2)
                  : '0.00' }}
                  <span *ngIf="manualInvoice.UpchargeType === '%'">%</span>
                </strong>
              </div>
            </div>
            <div class="form-group">
              <div class="d-flex justify-content-between">
                <label [style.color]="invoiceTemplateModel.fontColor"
                  >Tax</label
                >
                <strong>
                  <span *ngIf="manualInvoice.TaxType === '$'">$</span>
                  {{ manualInvoice.Tax ? manualInvoice.Tax.toFixed(2) : '0.00'
                  }}
                  <span *ngIf="manualInvoice.TaxType === '%'">%</span>
                </strong>
              </div>
            </div>
            <div
              class="form-group"
              *ngIf="manualInvoice.Tax && manualInvoice.TaxableTotal"
            >
              <div class="d-flex justify-content-between">
                <label [style.color]="invoiceTemplateModel.fontColor"
                  >Taxable Total</label
                >
                <strong
                  >$ {{ manualInvoice.TaxableTotal ?
                  manualInvoice.TaxableTotal.toFixed(2) : '0.00' }}</strong
                >
              </div>
            </div>
            <div
              class="form-group"
              *ngIf="manualInvoice.Tax && manualInvoice.NonTaxableTotal"
            >
              <div class="d-flex justify-content-between">
                <label [style.color]="invoiceTemplateModel.fontColor"
                  >Non-taxable Total</label
                >
                <strong
                  >$ {{ manualInvoice.NonTaxableTotal ?
                  manualInvoice.NonTaxableTotal.toFixed(2) : '0.00' }}</strong
                >
              </div>
            </div>
            <hr />
            <div class="form-group due-section">
              <div class="d-flex justify-content-between">
                <strong [style.color]="invoiceTemplateModel.fontColor">
                  Invoice Amount
                </strong>
                <strong>
                  $ {{ totalInvoiceAmount ? totalInvoiceAmount.toFixed(2) :
                  '0.00' }}
                </strong>
              </div>

              <ng-container *ngIf="!partialPayment; else amountPartial">
                <div class="d-flex justify-content-between">
                  <strong [style.color]="invoiceTemplateModel.fontColor"
                    >Amount Due</strong
                  >
                  <strong>
                    $ {{ manualInvoice.Balance && manualInvoice.Status !==
                    'Paid' ? manualInvoice.Balance.toFixed(2) : '0.00' }}
                  </strong>
                </div>
              </ng-container>

              <ng-template #amountPartial>
                <div class="d-flex justify-content-between">
                  <strong [style.color]="invoiceTemplateModel.fontColor"
                    >Partial Amount Due</strong
                  >
                  <strong class="currency-item">
                    {{ !["Partial", "Paid"].includes(manualInvoice.Status) ?
                    (getPartialAmountDue() | currency) : (0 | currency) }}
                  </strong>
                </div>
                <div class="d-flex justify-content-between">
                  <strong [style.color]="invoiceTemplateModel.fontColor"
                    >Total Amount Due</strong
                  >
                  <strong class="currency-item">
                    {{ !["Partial", "Paid"].includes(manualInvoice.Status) ?
                    (totalInvoiceAmount | currency) : (manualInvoice.AmountDue |
                    currency) }}
                  </strong>
                </div>
              </ng-template>

              <small class="xsmall"
                >Due on {{ manualInvoice.DueDate | date:'MM/dd/yyyy'}}</small
              >
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</div>
